var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateWorkflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create-workflow__Action Type=Create workflow, State=Enabled, Size=24",
    className: "create-workflow__Action create-workflow__Type=Create create-workflow__workflow, create-workflow__State=Enabled, create-workflow__Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create-workflow__Vector",
    className: "create-workflow__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.844 7.252a1.787 1.787 0 1 0-1.787 1.787v1.27l-.157-.004a3.057 3.057 0 0 1-2.896-2.896L2 7.252a3.057 3.057 0 0 1 3.057-3.057l.157.004a3.057 3.057 0 0 1 2.9 3.053l-.004.157a3.057 3.057 0 0 1-3.053 2.9v-1.27c.987 0 1.787-.8 1.787-1.787Zm8.28 6.707a1.787 1.787 0 1 0-1.787 1.787v1.27l-.157-.004a3.057 3.057 0 0 1-2.896-2.896l-.004-.157a3.057 3.057 0 0 1 3.057-3.057l.157.004a3.057 3.057 0 0 1 2.9 3.053l-.004.157a3.057 3.057 0 0 1-3.053 2.9v-1.27c.987 0 1.787-.8 1.787-1.787Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.866 9.352c.116 1.093.563 2.235 1.374 3.06.794.806 1.975 1.351 3.67 1.212l.105 1.264c-2.056.17-3.611-.5-4.68-1.586a5.581 5.581 0 0 1-.465-.541v4.463H4.6V9.42l1.266-.067Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.844 19.657a1.787 1.787 0 1 0-1.787 1.787v1.27l-.157-.005a3.057 3.057 0 0 1-2.896-2.895L2 19.657A3.057 3.057 0 0 1 5.057 16.6l.157.004a3.057 3.057 0 0 1 2.9 3.053l-.004.157a3.057 3.057 0 0 1-3.053 2.9v-1.27c.987 0 1.787-.8 1.787-1.787ZM17.772 9.011V7.005h-2.013a.749.749 0 0 1 0-1.498h2.013V3.52a.75.75 0 0 1 1.498 0v1.988h1.981a.75.75 0 0 1 0 1.498H19.27v2.006a.749.749 0 1 1-1.497 0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateWorkflow);
export default __webpack_public_path__ + "static/media/create_workflow.172377b63cca1d61411f683e5bef28ea.svg";
export { ForwardRef as ReactComponent };